import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledScrollableCell = styled(Flexer.Parent).attrs(() => ({
  alignItems: 'stretch',
}))`
  overflow: hidden;
  overflow-x: auto;
  &::-webkit-scrollbar {
    width: 4px !important;
    height: 4px !important;
    border-radius: 4px !important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(56, 62, 66, 0.3);
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0);
  }
`;

export default StyledScrollableCell;
